/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedPromoCode_displayInfo = {
    readonly pricing: {
        readonly showSale: boolean | null;
        readonly showNet: boolean | null;
    } | null;
    readonly " $refType": "PdpSharedPromoCode_displayInfo";
};
export type PdpSharedPromoCode_displayInfo$data = PdpSharedPromoCode_displayInfo;
export type PdpSharedPromoCode_displayInfo$key = {
    readonly " $data"?: PdpSharedPromoCode_displayInfo$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_displayInfo">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPromoCode_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showSale",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showNet",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};
(node as any).hash = 'e9794f3d1b7d5470b139290c49f7b040';
export default node;
